export const processContentSection = (
  content: string,
  fallbackContent: string,
  startMarker: string,
  endMarker: string,
  aiResponse: string,
  processor: (
    section: string,
    response: string,
    activityNum?: number,
  ) => string,
  activityNumber?: number,
) => {
  const contentToModify = content || fallbackContent;

  const startIndex = contentToModify.indexOf(startMarker);
  const endIndex = contentToModify.indexOf(endMarker);

  const beginning = contentToModify.substring(0, startIndex).trim();
  const section = contentToModify.substring(startIndex, endIndex).trim();
  const closing = contentToModify.substring(endIndex).trim();
  const newSection = processor(section, aiResponse, activityNumber);
  const newContent = `${beginning}\n${newSection}${closing}`;
  return newContent;
};
